export default "__VITE_ASSET__DVLGKG$l__"